export class Constants {
  public static clientId = "LoginSPA";

  private static baseRoot = "https://my.comftech.com";

  public static apiRoot = Constants.baseRoot;
  public static authRoot = Constants.baseRoot;

  public static readonly ZOOM_IN: number = 1;
  public static readonly ZOOM_OUT: number = 2;
  public static readonly ZOOM_RST: number = 3;
  
}
